import React, { useMemo } from 'react';
import { SettingsAPI } from '../../../../../../redux/settings/api/SettingsAPI';

function useLabFilters() {
  const { data: settings, ...rest } = SettingsAPI.useGetAllSettingsQuery();
  const data = useMemo(() => {
    return {
      labConnectionFeature: settings?.labConnectionFeature
        ? settings?.labConnectionFeature == 'true'
        : false,
      labBandwidthFeature: settings?.labBandwidthFeature
        ? settings?.labBandwidthFeature == 'true'
        : false,
      labTableFeature: settings?.labTableFeature
        ? settings?.labTableFeature == 'true'
        : false,
    };
  }, [settings]);
  return {
    data,
    ...rest,
  };
}

export default useLabFilters;
